import { render, staticRenderFns } from "./DictionaryDisciplines.vue?vue&type=template&id=492efae3&"
import script from "./DictionaryDisciplines.vue?vue&type=script&lang=js&"
export * from "./DictionaryDisciplines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports